import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import { Button, Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import {
	useDeleteUserMutation,
	useGetAllUsersQuery,
} from '../../../store/apiSlice';
import React, { useRef, useState } from 'react';

import { PageNav } from '../../../components/pageNav';
import { Helmet } from 'react-helmet-async';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import { Skeleton } from '@material-ui/lab/';
import { Link } from 'react-router-dom';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Const from '../../../defs/const';
import SearchIcon from '@material-ui/icons/Search';

const USER_STATUS_FILTER_OPTIONS = [
	{ value: Const.STATUS_ANY, label: 'Всички' },
	{ value: Const.STATUS_PENDING, label: 'Нов' },
	{ value: Const.STATUS_ENABLED, label: 'Одобрени' },
	{ value: Const.STATUS_REJECTED, label: 'Отхвърлен' },
	{ value: Const.STATUS_DISABLED, label: 'Неактивен' },
];

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
	},
	title: {
		paddingBottom: theme.spacing(2),
	},
	table: {
		minWidth: 650,
	},
	grid: {
		borderColor: theme.palette.secondary,
		borderBottom: '1px solid',
		marginTop: theme.spacing(1),
	},
	searchField: {
		minWidth: 140,
	},
	flex: {
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'wrap',
		gap: theme.spacing(1),
	},
}));

export function Users() {
	const classes = useStyles();
	const [pageInput, setPageInput] = useState(1);
	const [filter, setFilter] = useState(Const.STATUS_ANY);
	const [searchInputs, setSearchInputs] = useState({
		name: '',
		username: '',
		email: '',
	});
	const [appliedSearch, setAppliedSearch] = useState({
		name: '',
		username: '',
		email: '',
	});
	const { data: usersData, isFetching } = useGetAllUsersQuery({
		page: pageInput,
		filter,
		...appliedSearch,
	});

	const firstResultRef = useRef(null);

	const handlePageMove = (sign) => () => {
		setPageInput((prevState) => prevState + 1 * sign);
	};

	const handleSearchInputChange = (field) => (event) => {
		const { value } = event.target;

		setSearchInputs((prevState) => ({
			...prevState,
			[field]: value,
		}));
	};

	const applySearch = () => {
		setPageInput(1);
		setAppliedSearch({
			name: searchInputs.name.trim(),
			username: searchInputs.username.trim(),
			email: searchInputs.email.trim(),
		});
	};

	const handleSearchKeyDown = (event) => {
		if (event.key !== 'Enter') return;

		event.preventDefault();
		applySearch();
	};

	let users = usersData?.users || Array.from({ length: 20 });

	const [deleteUser] = useDeleteUserMutation();
	const handleDeleteCurry = (id) => {
		const handleDelete = (e) => {
			deleteUser({ id });
		};

		return handleDelete;
	};

	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (e) => {
		setAnchorEl(null);
		setPageInput(1);
		setFilter(e.target.getAttribute('data-value') || filter);
	};

	const selectedFilter =
		USER_STATUS_FILTER_OPTIONS.find((option) => option.value === filter) ||
		USER_STATUS_FILTER_OPTIONS[0];

	return (
		<div className={classes.root}>
			<CssBaseline />
			<Helmet>
				<title>Потребители</title>
			</Helmet>

			<Container maxWidth="lg" className={classes.container}>
				<Paper className={classes.paper}>
						<Typography
							className={classes.title}
							component="h1"
							variant="h4"
							role="alert"
						>
							Потребители
						</Typography>
						<div style={{ margin: '10px' }}>
							<Button
								aria-controls="simple-menu"
								aria-haspopup="true"
								onClick={handleClick}
							>
								{selectedFilter.label}
							</Button>
							<Menu
								id="simple-menu"
								anchorEl={anchorEl}
								keepMounted
								open={Boolean(anchorEl)}
								onClose={handleClose}
							>
								{USER_STATUS_FILTER_OPTIONS.map((option) => (
									<MenuItem
										key={option.value}
										data-value={option.value}
										onClick={handleClose}
									>
										{option.label}
									</MenuItem>
								))}
							</Menu>
						</div>
					<TableContainer component={Paper}>
						<Table className={classes.table} aria-label="Потребители">
							<TableHead>
								<TableRow>
									<TableCell>
										<TextField
											className={classes.searchField}
											label="Търси по име"
											variant="outlined"
											size="small"
											value={searchInputs.name}
											onChange={handleSearchInputChange('name')}
											onKeyDown={handleSearchKeyDown}
											inputProps={{
												'aria-label': 'Търсене по име',
											}}
										/>
									</TableCell>
									<TableCell>
										<TextField
											className={classes.searchField}
											label="Търси по потребителско име"
											variant="outlined"
											size="small"
											value={searchInputs.username}
											onChange={handleSearchInputChange('username')}
											onKeyDown={handleSearchKeyDown}
											inputProps={{
												'aria-label': 'Търсене по потребителско име',
											}}
										/>
									</TableCell>
									<TableCell>
										<TextField
											className={classes.searchField}
											label="Търси по имейл"
											variant="outlined"
											size="small"
											value={searchInputs.email}
											onChange={handleSearchInputChange('email')}
											onKeyDown={handleSearchKeyDown}
											inputProps={{
												'aria-label': 'Търсене по имейл',
											}}
										/>
									</TableCell>
									<TableCell align="left">
										<Button
											variant="contained"
											color="primary"
											startIcon={<SearchIcon />}
											onClick={applySearch}
											disabled={isFetching}
											aria-label="Търси потребители"
										>
											Търси
										</Button>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Име</TableCell>
									<TableCell>Потребителско име</TableCell>
									<TableCell>Имейл</TableCell>
									<TableCell>Операция</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{users.map((user, index) => {
									const isInactive =
										user?.is_active === false ||
										user?.tbl_profile?.deleted === true ||
										user?.tbl_profile?.status === Const.STATUS_DISABLED;
									const fullName = `${user?.first_name || ''} ${
										user?.last_name || ''
									}`.trim();
									const displayName = fullName || 'Няма име';
									const accessibleName = fullName || user?.username || displayName;
									const textStyle = {
										textDecoration: isInactive ? 'line-through' : 'none',
									};

									return (
										<TableRow key={index}>
											<TableCell scope="row">
												{!isFetching ? (
													<Link
														ref={firstResultRef}
														to={`/admin/users/${user?.id}`}
														state={{ name: user?.first_name }}
														aria-label={
															isInactive
																? `${accessibleName}, неактивен`
																: accessibleName
														}
														style={textStyle}
													>
														{displayName}
													</Link>
												) : (
													<Skeleton width={'25vw'} />
												)}
											</TableCell>
											<TableCell>
												{!isFetching ? (
													<Link
														to={`/admin/users/${user?.id}`}
														state={{ name: user?.first_name }}
														aria-label={`Потребителско име ${user?.username || 'няма'}`}
														style={textStyle}
													>
														{user?.username || 'Няма'}
													</Link>
												) : (
													<Skeleton width={'20vw'} />
												)}
											</TableCell>
											<TableCell>
												{!isFetching ? (
													<span style={textStyle}>
														{user?.email || 'Няма'}
													</span>
												) : (
													<Skeleton width={'20vw'} />
												)}
											</TableCell>
											<TableCell align="left">
												<Link
													ref={firstResultRef}
													to={`/admin/users/edit/${user?.id}`}
													state={{ name: user?.name }}
												>
													<Button startIcon={<EditIcon />}></Button>
												</Link>
												<Button
													startIcon={<DeleteIcon />}
													onClick={handleDeleteCurry(user?.id)}
												></Button>
											</TableCell>
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</TableContainer>
					{users.length ? (
						<PageNav
							isFetching={isFetching}
							maxPage={usersData?.pageCount}
							handlePageMove={handlePageMove}
							pageInput={pageInput}
						/>
					) : (
						<Typography>Няма намерени потребители.</Typography>
					)}
				</Paper>
			</Container>
		</div>
	);
}
